<template>
  <!-- <div>
    <router-view></router-view>
  </div>-->
  <div class="pageContent">
    <div class="inspectionReport">
      <div class="inspectionContent">
        <div class="dataTitle">
          <van-icon
            class="hospiyalsArrowLeft"
            style="top: 16px;"
            name="arrow-left"
            @click="onBack"
            v-if="forwardingReport"
          />
          <!-- reportSee==1&& -->
          <div class="title" >
            <!-- v-if="(institution_id !== '73000005'&&Storage.get('examStatus')==9)||!Storage.get('examStatus')" -->
            <div
              class="content"
             v-if="(Storage.get('examStatus')==9)||!Storage.get('examStatus')"
              :class="[reportBool==1?'action':'']"
              @click="toReport"
            >检查报告</div>
            <!-- v-if="((institution_id !== '73000005'&&Storage.get('examStatus')==9)||!Storage.get('examStatus')) && reportInfo[0].is_dcm ==='1'" -->
            <div class="line" v-if="((Storage.get('examStatus')==9)||!Storage.get('examStatus')) && reportInfo[0].is_dcm ==='1'">|</div>
            <div class="content" :class="[reportBool==2?'action':'']" v-if="reportInfo[0].is_dcm ==='1'" @click="toPortrait">数字影像</div>
            <div class="line" v-if="reportInfo[0].is_dcm ==='1' && institution_id === '43600001' || institution_id === '73000005'">|</div>
            <div :class="['content', reportBool==4?'action':'']" v-if="institution_id === '43600001' || institution_id === '73000005'" @click="toAttachment">附件</div>
            <div class="line" v-if="isForward">|</div>
            <div
              class="content"
              v-if="isForward"
              :class="[reportBool==3?'action':'']"
              @click="toForwarding"
            >转发报告</div>
            <!-- <div class="line" v-if="forwardingReport&&examId">|</div>
            <div class="content" @click="toForwarding" v-if="forwardingReport&&examId">转发报告</div>-->
          </div>
        </div>
        <!-- 组件 -->
        <div v-if="reportBool==1">
          <inspectionReport v-if="Storage.get('code') != 2 && Storage.get('examStatus') != 1" />
        </div>
        <portrait v-else-if="reportBool==2" />
        <forwardingReport v-else-if="reportBool==3" />
        <attachment v-else-if="reportBool==4" />
      </div>
    </div>
  </div>
</template>
<script>
import inspectionReport from "./components/inspectionReport.vue";
import portrait from "./components/portrait.vue";
import forwardingReport from "./components/forwardingReport.vue";
import attachment from "./components/attachment.vue";

import Storage from "@/tools/storage";
export default {
  name: "reportInfoOuter",
  components: { inspectionReport, portrait, forwardingReport, attachment },
  data() {
    return {
      reportBool: 1,
      // portraitBool: false,
      forwardingReport: true,
      institution_id: "",
      isForward: false
    };
  },
  watch:{
    '$route.query.institution_id': {
      handler(newvalue,oldvalue){
        this.institution_id = newvalue
        if(this.institution_id == '43600001' || this.institution_id == '43800001' || this.institution_id == '27100005' || this.institution_id == '25500005' || this.institution_id == '30000004'){
          this.isForward = true
        }else{
          this.isForward = false
        }
      },
      deep: true,
      immediate: true,
      reportInfo: []
    }
  },
  methods: {
    toReport() {
      this.reportBool = 1;
      Storage.set("Montmorillonite", "1");
    },
    toPortrait() {
      this.reportBool = 2;
    },
    toForwarding() {
      this.reportBool = 3;
    },
    onBack() {
      this.$router.go(-1);
    },
    toAttachment() {
      this.reportBool = 4
    }
  },
  mounted() {
    if (Storage.get("reportPermissions")) {
      this.forwardingReport = false;
    }
  },
  created() {
    this.institution_id = this.$route.query.institution_id;
    this.reportBool = this.$route.query.reportBool || 1;
    // this.reportInfo = JSON.parse(Storage.get("reportInfo"))||[{is_dcm: '1'}];
    let url = window.location.href;
    let urlParams = new URLSearchParams(url.split('?')[1]);
    let isDcm = urlParams.get('is_dcm');
    if (url.indexOf("short=1") != -1 && url.indexOf("is_dcm=") != -1) {
      this.reportInfo = [{is_dcm: isDcm}];
    }else{
      this.reportInfo = JSON.parse(Storage.get("reportInfo"))||[{is_dcm: '1'}];
    }
    if(this.institution_id == '43600001' || this.institution_id == '43800001' || this.institution_id == '27100005' || this.institution_id == '25500005' || this.institution_id == '30000004'){
      this.isForward = true
    }else{
      this.isForward = false
    }
    this.reportSee = Storage.get("reportSee")
    // if ( this.institution_id == "73000005" ||( this.reportSee == "1"&&Storage.get('examStatus')!=9&& this.reportInfo[0].is_dcm=='1')) {
    if (this.reportSee == "1"&&Storage.get('examStatus')!=9&& this.reportInfo[0].is_dcm=='1') {
      this.reportBool = 2;
    }else if( this.reportSee == "1" && Storage.get('examStatus')!=9 && this.reportInfo[0].is_dcm=='2'){
      this.reportBool = 4;
    }
  }
};
</script>
<style scoped>
</style>

